import FormsStore from '../../Stores/Forms'

import request from '../Functions/ajax/request'

export default async function BrandsLogosLoader ({ params })
{
	return { params, page: getPage({ params }) };
}

const FORM_NAME = 'BrandsLogos';

async function getPage ()
{
	try
	{
		var { data } = await request('/brands-logos/form-get')
		.config({ })
		.post();
	}
	catch (e)
	{
		data = { };
	}

	FormsStore.update(function (store)
	{
		store[FORM_NAME] =
		{
			id: data.id,
			logos: data.logos || [],
			title: data.title || ''
		};
	});

	return { partners_logos: data };
}